module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-list"
  }, [(_vm.ds_name === 'WNLI') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][3]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][2]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[2]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'DIAGNOSTICS') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][7]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][5]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][6]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[7]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[5]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[6]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'QNLI') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][3]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][2]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[2]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'QQP') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][5]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][3]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][4]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[5]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[4]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'RTE') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][3]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][2]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[2]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'SST-2') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][1]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][0]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[0]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'STS-B') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v(_vm._s(_vm.items[0][0]))]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v(_vm._s(_vm.items[0][9]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][7]))]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v(_vm._s(_vm.items[0][8]))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[9]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[7]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[8]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'DPR') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item[1]))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[4]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[3]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'CB' || _vm.ds_name === 'RTE-DIAGNOSTIC') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item['idx']))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item['label']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['premise']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['hypothesis']))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'COPA') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item['idx']))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item['label']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['premise']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['choice1']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['choice2']))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'WIC') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item['idx']))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item['word']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['label']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['sentence1'].replace(item['word'], ("[" + (item['word']) + "]"))))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['sentence2'].replace(item['word'], ("[" + (item['word']) + "]"))))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'BOOLQ') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [_vm._l((_vm.items), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(item['idx']))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item['label']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['passage']))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['question']))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (_vm.ds_name === 'CMRC' || _vm.ds_name === 'DRCD') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('h2', {
      staticClass: "ui horizontal divider header"
    }, [_c('i', {
      staticClass: "file outline icon"
    }), _vm._v("\n        " + _vm._s(item['title']) + "\n      ")]), _vm._v(" "), _vm._l((item['paragraphs']), function(row, ri) {
      return [_c('div', {
        staticClass: "paragraph"
      }, [_c('p', [_vm._v(_vm._s(row['context']))]), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _vm._l((row['qas']), function(q, qi) {
        return _c('div', [_c('p', {
          staticClass: "question"
        }, [_vm._v(_vm._s(q['question']))]), _vm._v(" "), _c('div', {
          staticClass: "answers"
        }, _vm._l((q['answers']), function(a, ai) {
          return _c('span', {
            staticClass: "answer"
          }, [_vm._v("\n                " + _vm._s(ai + 1) + ": " + _vm._s(a['text'])), _c('span', [_vm._v("(" + _vm._s(a['answer_start']) + ")")]), _vm._v("    \n              ")])
        }), 0)])
      })], 2)]
    })], 2)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (_vm.ds_name === 'MULTIRC') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('div', {
      staticClass: "paragraph"
    }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(item['passage']['text']))])]), _vm._v(" "), _vm._m(6, true), _vm._v(" "), _vm._l((item['passage']['questions']), function(row, ri) {
      return [_c('div', {
        staticClass: "question"
      }, [_c('p', [_vm._v(_vm._s(row['question']))]), _vm._v(" "), _c('div', {
        staticClass: "answers"
      }, _vm._l((row['answers']), function(a, ai) {
        return _c('div', {
          staticClass: "statement"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (a.label),
            expression: "a.label"
          }],
          staticClass: "annotate-id",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(a.label) ? _vm._i(a.label, null) > -1 : (a.label)
          },
          on: {
            "change": function($event) {
              var $$a = a.label,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(a, "label", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(a, "label", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(a, "label", $$c)
              }
            }
          }
        }), _vm._v(" "), _c('label', [_vm._v(_vm._s(a['text']))])])
      }), 0)])]
    })], 2)])] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (_vm.ds_name === 'RECORD') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('div', {
      staticClass: "paragraph"
    }, [_c('h2', {
      staticClass: "ui horizontal divider header"
    }, [_c('i', {
      staticClass: "file outline icon"
    }), _vm._v("\n          " + _vm._s(item['source']) + "\n        ")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v(_vm._s(item['passage']['text']))])]), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _vm._l((item['qas']), function(row, ri) {
      return [_c('div', {
        staticClass: "question"
      }, [_c('p', [_vm._v(_vm._s(row['query']))]), _vm._v(" "), _c('div', {
        staticClass: "answers"
      }, _vm._l((row['answers']), function(a, ai) {
        return _c('span', {
          staticClass: "answer"
        }, [_c('div', [_vm._v(_vm._s(a['text']))]), _c('div', {
          staticClass: "annotate-id"
        }, [_vm._v(_vm._s(a['label']))])])
      }), 0)])]
    })], 2)])] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return (_vm.ds_name === 'RACE') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('div', {
      staticClass: "paragraph"
    }, [_c('div', {}, [_c('p', [_vm._v(_vm._s(item['article']))])]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _vm._l((item['questions']), function(q, qi) {
      return [_c('div', {
        staticClass: "questions"
      }, [_c('div', {}, [_vm._v(_vm._s(q) + " "), _c('span', {
        staticClass: "answer"
      }, [_vm._v(_vm._s(item['answers'][qi]))])]), _vm._v(" "), _c('div', {
        staticClass: "options"
      }, _vm._l((item['options'][qi]), function(opt, opti) {
        return _c('span', {
          staticClass: "option"
        }, [_c('div', [_vm._v(_vm._s(['A)', 'B)', 'C)', 'D)'][opti]) + " " + _vm._s(opt))])])
      }), 0)])]
    })], 2)])] : _vm._e()
  }), _vm._v(" "), (_vm.ds_name === 'SCITAIL') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(item[2]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item[1]))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), (_vm.ds_name === 'WINOGRANDE') ? [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', [_vm._l((_vm.items.slice(1)), function(item, index) {
    return [_c('tr', [_c('td', {
      staticClass: "col-index"
    }, [_vm._v(_vm._s(index))]), _vm._v(" "), _c('td', {
      staticClass: "col-label"
    }, [_vm._v(_vm._s(("" + (item['option1']) + (item['answer']==='1'?'(x)':'') + ", " + (item['option2']) + (item['answer']==='2'?'(x)':''))))]), _vm._v(" "), _c('td', {
      staticClass: "col-sent"
    }, [_vm._v(_vm._s(item['sentence']))])])]
  })], 2)])] : _vm._e(), _vm._v(" "), _vm._l((_vm.items.slice(1)), function(item, index) {
    return (_vm.ds_name === 'SWAG') ? [_c('div', {
      staticClass: "row-block"
    }, [_c('div', {
      staticClass: "question"
    }, [_c('p', [_vm._v(_vm._s(item[2]) + "...")]), _vm._v(" "), _c('div', {
      staticClass: "options"
    }, [_c('div', {
      staticClass: "option gold"
    }, [_vm._v(_vm._s(item[3]))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item[4]))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item[5]))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item[6]))]), _vm._v(" "), _c('div', {
      staticClass: "option"
    }, [_vm._v(_vm._s(item[7]))])])])])] : _vm._e()
  }), _vm._v(" "), (_vm.ds_name === 'basic') ? [_c('ul', {
    staticClass: "basic"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_vm._v(_vm._s(item.summary))])])])
  }), 0)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Premise")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Hypothesis")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Premise")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Hypothesis")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Premise")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Choice 1")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Choice 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Word")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence 1")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Passage")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Question")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "question circle outline icon"
  }), _vm._v("\n            Questions\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "question circle outline icon"
  }), _vm._v("\n          Questions\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "question circle outline icon"
  }), _vm._v("\n          Questions\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "ui horizontal divider header"
  }, [_c('i', {
    staticClass: "question circle outline icon"
  }), _vm._v("\n          Questions\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence 1")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-index"
  }, [_vm._v("Index")]), _vm._v(" "), _c('th', {
    staticClass: "col-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('th', {
    staticClass: "col-sent"
  }, [_vm._v("Sentence")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d5ae216"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DList.vue
// module id = 78
// module chunks = 1